import { render } from "./index.vue?vue&type=template&id=21a7974a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=21a7974a&scoped=true&lang=css"

import exportComponent from "D:\\code\\csxlib-digital-resource\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a7974a"]])

export default __exports__